import styled from '@emotion/styled';
import { colors, spacing, typography } from 'component-library';

export const ListWrapper = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const UserItemWrapper = styled.div<{ disabled?: boolean; locked?: boolean }>`
  display: flex;
  flex-flow: row;
  align-items: center;
  gap: ${spacing.xsmall};
  padding: ${spacing.xmsmall};
  border-bottom: 1px solid ${colors.monochrome.grey20};

  &:first-of-type {
    border-top: 1px solid ${colors.monochrome.grey20};
  }

  ${({ disabled }) =>
    disabled &&
    `
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  `}

  ${({ locked, disabled }) =>
    locked &&
    !disabled &&
    `
    cursor: default;
    pointer-events: none;
  `}

  ${({ disabled, locked }) =>
    !disabled &&
    !locked &&
    `
    &:hover {
      background-color: ${colors.background.grey};
      cursor: pointer;
    }
  `}
`;

export const UserItemContent = styled.div`
  display: flex;
  flex-flow: column;
`;

export const UserName = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
`;

export const UserEmailRow = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
  gap: ${spacing.tiny};
`;

export const UserEmail = styled.span`
  ${typography.body.medium};
  color: ${colors.base.black};
`;

export const UserBadge = styled.span<{ variant: 'success' | 'error' | 'neutral' }>`
  ${typography.body.small};
  display: flex;
  justify-content: center;
  padding: 0 ${spacing.tiny};
  border: 1px solid;
  height: 20px;
  gap: 8px;

  ${({ variant }) => {
    switch (variant) {
      case 'success':
        return `
          background-color: ${colors.alerts.successTint3};
          color: ${colors.alerts.successShade2};
          border-color: ${colors.alerts.successTint1};
        `;
      case 'error':
        return `
          background-color: ${colors.alerts.errorTint3};
          color: ${colors.alerts.errorShade2};
          border-color: ${colors.alerts.errorTint1};
        `;
      case 'neutral':
        return `
          background-color: ${colors.monochrome.grey10};
          color: ${colors.primary.grey};
          border-color: ${colors.monochrome.grey20};
        `;
    }
  }}
`;
